import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { ConversationListContainer } from '@/features/messaging';

export default function MessagesPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleConversationSelect = (orderId: string) => {
    navigate(`/orders/${orderId}/conversation`);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10">
          <MessageSquare className="size-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">{t('messaging.title', 'Messages')}</h1>
          <p className="text-sm text-muted-foreground">
            {t('messaging.pageDescription', 'Gérez vos conversations avec vos clients')}
          </p>
        </div>
      </div>

      <div className="rounded-lg border bg-card overflow-hidden" style={{ height: 'calc(100vh - 200px)' }}>
        <ConversationListContainer onConversationSelect={handleConversationSelect} />
      </div>
    </div>
  );
}
